/**
 * CUANTAS DEL CORPUS SE PUEDEN LEER — ARCHIVO GENERADO, no editar.
 *
 *     python herramientas/corpus_cl.py --escribir
 *
 * `legibles` es lo que la intranet enseña de verdad. NO es el tamano del
 * corpus reunido (5.778): de ahi salen las ya publicadas como nuestras y
 * las rotas en origen, que no se pueden leer. Lo que el sitio promete
 * tiene que ser lo que el sitio entrega.
 */
export const CORPUS_LEGIBLES = 5425;
export const CORPUS_CANALIZADORES = 224;
/** Las que se estudiaron y siguen en el corpus (legibles + propias publicadas + rotas), sin las eliminadas. */
export const CORPUS_ANALIZADO = 5433;
